// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration - replace with your actual config
const firebaseConfig = {
  apiKey: "AIzaSyB-fWJmZeyaa_oH-whH0xbB3Uyi03O7Y54",
  authDomain: "waka-build.firebaseapp.com",
  projectId: "waka-build",
  storageBucket: "waka-build.firebasestorage.app",
  messagingSenderId: "156641799962",
  appId: "1:156641799962:web:f9d4bcb37610524ed646a3",
  measurementId: "G-8856V455KC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { app, auth, db, storage, analytics };